﻿import { ParameterDefinition } from "./Model/ParameterDefinition";

export class DefaultParameterDefinitions {
    public static Parameters: { [parameterId: string]: ParameterDefinition } = {
        // Wind

        "WindSpeed/kts_Raw": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "WindSpeed/kts_Raw_Filtered": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "WindDirection/deg_Raw": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "WindDirection/deg_Raw_Filtered": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },

        "WindSpeed/kts_10min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "WindSpeed/kts_1min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "1 min",
        },
        "WindSpeed/kts_2min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "2 min",
        },
        "WindSpeed/kts_3sec_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "3 sec",
        },
        "WindSpeed/kts_8min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "8 min",
        },
        "GustSpeed/kts_10min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "GustSpeed/kts_1min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "1 min",
        },
        "GustSpeed/kts_8min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "8 min",
        },
        "WindDirection/deg_10min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "WindDirection/deg_1min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "1 min",
        },
        "WindDirection/deg_3sec_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "3 sec",
        },
        "WindDirection/deg_2min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "2 min",
        },
        "WindDirection/deg_8min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "8 min",
        },
        "WindDirection/Backed_deg_10min": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "WindDirection/Veered_deg_10min": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "WindSelectedSensorId": {
            AllowPlot: false,
            Default: true,
        },

        //Forecast
        "WindDirection/deg_10m": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 m",
        },
        "WindSpeed/kts_10m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 m",
        },
        "WindSpeed/kts_50m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "50 m",
        },
        "WindSpeed/kts_100m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "100 m",
        },
        "GustSpeed/kts_10m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 m",
        },
        "GustSpeed/kts_50m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "50 m",
        },
        "GustSpeed/kts_100m": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "100 m",
        },
        "Tp_WindSea/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tp_Swell1/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Visibility/m": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },
        "First_CloudBaseHeight/ft": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "BarometricPressure_QNH/mbar": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
        },
        "BarometricPressure/mbar": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
        },
        "BarometricPressure/mbar_10min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
        },
        // Meteorological
        "WaterTemp/degC": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
        },
        "WaterTemp/degC_10min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "WaterTemp/degC_60min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "AirTempDryBulb/degC": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
        },
        "AirTempDryBulb/degC_10min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "AirTempDryBulb/degC_60min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "AirTempDryBulb/degC_20min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "BarometricPressure/QFE_mbar_10min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "BarometricPressure_QNH/mbar_10min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "BarometricPressure_QFE/mbar_20min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "BarometricPressure_QNH/mbar_20min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "BarometricPressure_QNH/mbar_60min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "Dewpoint/degC_10min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "RelativeHumidity/pc_10min_Mean": {
            AxisLabel: "Humidity",
            PlotLine: true,
            Units: "%",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "RelativeHumidity/pc_20min_Mean": {
            AxisLabel: "Humidity",
            PlotLine: true,
            Units: "%",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "AirTempDryBulb/degC_1min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "BarometricPressure/QFE_mbar_1min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "BarometricPressure_QNH/mbar_1min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Dewpoint/degC_1min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Dewpoint/degC_20min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "RelativeHumidity/pc_1min_Mean": {
            AxisLabel: "Humidity",
            PlotLine: true,
            Units: "%",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "WindChill/degC_10min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "SolarRadiation/mWpcm2_10min_Mean": {
            AxisLabel: "Solar",
            PlotLine: true,
            Units: "Wb / cm^2",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "SolarRadiation/mWpcm2_60min_Mean": {
            AxisLabel: "Solar",
            PlotLine: true,
            Units: "Wb / cm^2",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "METAR": {
            AllowPlot: false,
            Default: true,
        },

        // Cloud, Vis, Weather

        "Visibility/m_10min_Mean": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Visibility/m_20min_Mean": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Visibility/m_Inst_Mean": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "Inst",
        },
        "PresentWeather": {
            AllowPlot: false,
            Default: true,
        },
        "RainfallIntensity/mmphour": {
            AxisLabel: "Rainfall",
            PlotLine: true,
            Units: "mm / hour",
            AllowPlot: true,
            Default: true,
        },
        "Evaporation/mmphour": {
            AxisLabel: "Evaporation",
            PlotLine: true,
            Units: "mm / hour",
            AllowPlot: true,
            Default: true,
        },
        "Rainfall/mmSince9am": {
            AxisLabel: "Rainfall",
            PlotLine: true,
            Units: "mm",
            AllowPlot: true,
            Default: true,
        },
        "First_CloudBaseHeight/ft_30min": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Second_CloudBaseHeight/ft_30min": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Third_CloudBaseHeight/ft_30min": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "First_CloudCover/30min": {
            AllowPlot: false,
            Default: true,
            Suffix: "30 min",
        },
        "Second_CloudCover/30min": {
            AllowPlot: false,
            Default: true,
            Suffix: "30 min",
        },
        "Third_CloudCover/30min": {
            AllowPlot: false,
            Default: true,
            Suffix: "30 min",
        },
        "First_CloudBaseHeight/ft_Inst": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Second_CloudBaseHeight/ft_Inst": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Third_CloudBaseHeight/ft_Inst": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },

        // Vessel

        "Heading/deg": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Vessel_Latitude/deg": {
            AxisLabel: "Latitude",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },
        "Vessel_Longitude/deg": {
            AxisLabel: "Longitude",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },
        "Pitch/BowUp_deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Pitch/BowDown_deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Roll/Left_deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Roll/Right_deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Inclination/deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Heave/Rate_mps_20min_Max": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "mps",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Heave/Period_s_20min_Mean": {
            AxisLabel: "Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Heave/m_20min_Max": {
            AxisLabel: "Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "MMS/20min": {
            AxisLabel: "MMS",
            PlotLine: true,
            AllowPlot: true,
            Default: true,
        },
        "MSI/20min": {
            AxisLabel: "MSI",
            PlotLine: true,
            AllowPlot: true,
            Default: true,
        },
        "WSI/20min": {
            AxisLabel: "WSI",
            PlotLine: true,
            AllowPlot: true,
            Default: true,
        },
        "Excursion/Bearing_deg_1min": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "1 min",
        },
        "Excursion/Distance_m_1min_Max": {
            AxisLabel: "Distance",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },

        // Wave (Time Domain)

        "HsT/m_30min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "HmaxT/m_30min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "HmaxT/m": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "THmaxT/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "CmaxT/m_30min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "CassT/m_30min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Tz/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "TmaxT/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Draft/m_30min": {
            AxisLabel: "Draft",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "AirGap/m_30min": {
            AxisLabel: "Air Gap",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "AirGap/m_10min": {
            AxisLabel: "Air Gap",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "AirGap/m_Raw": {
            AxisLabel: "Air Gap",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },

        // Wave (Spectral)

        "Hs/m_30min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Hs/m_20min": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "20 min",
        },
        "Hs/m": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Hs_WindSea/m": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Hs_Swell1/m": {
            AxisLabel: "Wave Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "MeanWaveDirection/deg_30min": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "PeakWaveDirection/deg_30min": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "MeanSpreading/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "MeanSpreading_WindSea/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "MeanSpreading_Swell1/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "PeakSpreading/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "PeakSpreading_WindSea/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "PeakSpreading_Swell1/deg_30min": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "30 min",
        },
        "MeanWaveDirection/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanWaveDirection_WindSea/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanWaveDirection_Swell1/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanWaveDirection/degM": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°M FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanWaveDirection_WindSea/degM": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°M FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanWaveDirection_Swell1/degM": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°M FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakWaveDirection/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakWaveDirection_WindSea/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakWaveDirection_Swell1/deg": {
            AxisLabel: "Wave Direction",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanSpreading/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakSpreading/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Tc/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "T1/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "T2/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "Tp/s_30min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "30 min",
        },
        "T1/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tm/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tm_WindSea/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tm_Swell1/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "T2/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "T2_WindSea/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "T2_Swell1/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tm-1/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "UnidirectivityIndex": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tp/s": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Tp/s_20min": {
            AxisLabel: "Wave Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "20 min",
        },
        "WaveSpectrum/30min": {
            AllowPlot: false,
            Default: true,
            Suffix: "30 min",
        },

        // Current

        "Total_CurrentSpeed/Peak_mps_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Surface_mps_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Surface_mps_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Middle_mps_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Bottom_mps_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Peak_kts_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Surface_kts_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Surface_kts_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Middle_kts_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentSpeed/Bottom_kts_10min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentDirection/Peak_deg_10min_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentDirection/Surface_deg_10min_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentDirection/Surface_deg_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Total_CurrentDirection/Middle_deg_10min_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentDirection/Bottom_deg_10min_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "MeasurementDepth/Total_Current_Peak_deg_10min_Mean": {
            AxisLabel: "Depth",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },

        // Water Level

        "Total_SeaElevation/m_30min_Max": {
            AxisLabel: "Sea Surface",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "30 min",
        },
        "Total_SeaElevation/m_30min_Mean": {
            AxisLabel: "Sea Surface",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "30 min",
        },
        "Total_SeaElevation/m_10min_Max": {
            AxisLabel: "Sea Surface",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Total_SeaElevation/m_10min_Mean": {
            AxisLabel: "Sea Surface",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        //Tide
        "Tide_Predicted/m_LAT": {
            AxisLabel: "Tide",
            PlotLine: true,
            Units: "m (LAT)",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Tide/m": {
            AxisLabel: "Tide",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        // Buoy
        "Buoy_Latitude/deg": {
            AxisLabel: "Latitude",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },
        "Buoy_Longitude/deg": {
            AxisLabel: "Longitude",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },
        "Buoy_Excursion/m": {
            AxisLabel: "Buoy Excursion",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },
        "Buoy_BatteryLife/weeks": {
            AxisLabel: "Battery Life",
            PlotLine: true,
            Units: "weeks",
            AllowPlot: true,
            Default: true,
        },
        "Buoy_BatteryVoltage/V": {
            AxisLabel: "Battery Voltage",
            PlotLine: true,
            Units: "V",
            AllowPlot: true,
            Default: true,
        },
        "BatteryVoltage/V": {
            AxisLabel: "Battery Voltage",
            PlotLine: true,
            Units: "V",
            AllowPlot: true,
            Default: true,
        },
        // Helideck Status
        "Helideck_Status": {
            AxisLabel: "Status",
            PlotLine: true,
            Units: "",
            AllowPlot: true,
            Default: true,
        },

        "RiserTension/kN": {
            AxisLabel: "Riser Tension",
            PlotLine: true,
            Units: "kN",
            AllowPlot: true,
            Default: true,
        },

        "RiserTensionerPressure1/psi": {
            AxisLabel: "Tensioner Pressure",
            PlotLine: true,
            Units: "psi",
            AllowPlot: true,
            Default: true,
        },

        "RiserTensionerPressure2/psi": {
            AxisLabel: "Tensioner Pressure",
            PlotLine: true,
            Units: "psi",
            AllowPlot: true,
            Default: true,
        },

        "RiserTensionerPressure3/psi": {
            AxisLabel: "Tensioner Pressure",
            PlotLine: true,
            Units: "psi",
            AllowPlot: true,
            Default: true,
        },

        "RiserTensionerPressure4/psi": {
            AxisLabel: "Tensioner Pressure",
            PlotLine: true,
            Units: "psi",
            AllowPlot: true,
            Default: true,
        },

        "Draft/m": {
            AxisLabel: "Draft",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },

        "InclinationNS/deg": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },

        "InclinationEW/deg": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },

        "Pitch/deg": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },

        "Roll/deg": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
        },

        "Heave/m": {
            AxisLabel: "Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },

        "SurgeAcceleration/mps2": {
            AxisLabel: "Acceleration",
            PlotLine: true,
            Units: "mps^2",
            AllowPlot: true,
            Default: true,
        },

        "SwayAcceleration/mps2": {
            AxisLabel: "Acceleration",
            PlotLine: true,
            Units: "mps^2",
            AllowPlot: true,
            Default: true,
        },

        "BuoyDisplacementNorth/m_Raw": {
            AxisLabel: "Buoy Displacement",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },

        "BuoyDisplacementWest/m_Raw": {
            AxisLabel: "Buoy Displacement",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },

        "BuoyDisplacementVertical/m_Raw": {
            AxisLabel: "Buoy Displacement",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
        },

        "AirTempDryBulb/degC_4min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "4 min",
        },
        "AirTempWetBulb/degC_10min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "BarometricPressure/mbar_1min_Mean": {
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Dewpoint/degC_4min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "4 min",
        },
        "First_CloudBaseHeight/ft_10min": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "GustSpeed/kts_10m_10min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 m, 10 min",
        },
        "GustSpeed/kts_10m_2min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 m, 2 min",
        },
        "GustSpeed/kts_2min": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "2 min",
        },
        "Heading/deg_10min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "Heading/deg_1min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "1 min",
        },
        "Heading/deg_20min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "20 min",
        },
        "Heading/deg_2min_Mean": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "2 min",
        },
        "Heading/deg_Inst": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Heave/Period_s_10min_Mean": {
            AxisLabel: "Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Heave/Period_s_1min_Mean": {
            AxisLabel: "Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Heave/Rate_mps_10min_2rms": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "mps",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "10 min",
        },
        "Heave/Rate_mps_10min_Max": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "mps",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Heave/Rate_mps_20min_2rms": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "mps",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Heave/Rate_mps_20min_4rms": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "mps",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Heave/m_10min_Max": {
            AxisLabel: "Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Heave/m_1min_Max": {
            AxisLabel: "Height",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "MeanSpreading_Swell1/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeanSpreading_WindSea/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "MeasurementDepth/Total_Current_Peak_deg_Mean": {
            AxisLabel: "Depth",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakSpreading_Swell1/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "PeakSpreading_WindSea/deg": {
            AxisLabel: "Wave Spreading",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Pitch/deg_10min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Pitch/deg_10min_Min": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Pitch/deg_1min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Pitch/deg_1min_Min": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Pitch/deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Pitch/deg_20min_Min": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "RainfallIntensity/mmp10min": {
            AxisLabel: "Rainfall",
            PlotLine: true,
            Units: "mm / 10 min",
            AllowPlot: true,
            Default: true,
        },
        "RainfallIntensity/mmpday": {
            AxisLabel: "Rainfall",
            PlotLine: true,
            Units: "mm / day",
            AllowPlot: true,
            Default: true,
        },
        "RainfallIntensity/mmpmin": {
            AxisLabel: "Rainfall",
            PlotLine: true,
            Units: "mm / min",
            AllowPlot: true,
            Default: true,
        },
        "RelativeHumidity/pc_4min_Mean": {
            AxisLabel: "Humidity",
            PlotLine: true,
            Units: "%",
            AllowPlot: true,
            Default: true,
            Suffix: "4 min",
        },
        "Roll/deg_10min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Roll/deg_1min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Roll/deg_1min_Min": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Roll/deg_20min_Max": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Roll/deg_20min_Min": {
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "SeaTemp/deg_1hour_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "Second_CloudBaseHeight/ft_10min": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "SolarRadiation/mWpcm2_1min_Mean": {
            AxisLabel: "Solar",
            PlotLine: true,
            Units: "W / cm^2",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "Surge/m_10min_Max": {
            AxisLabel: "Surge/Sway",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Sway/m_10min_Max": {
            AxisLabel: "Surge/Sway",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "10 min",
        },
        "Tc/s": {
            AxisLabel: "Period",
            PlotLine: true,
            Units: "s",
            AllowPlot: true,
            Default: true,
        },
        "Third_CloudBaseHeight/ft_10min": {
            AxisLabel: "Cloud Height",
            PlotLine: true,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "Total_CurrentDirection/Bottom_deg_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Total_CurrentDirection/Middle_deg_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Total_CurrentDirection/Peak_deg_1hour_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "1 hour",
        },
        "Total_CurrentDirection/Peak_deg_20min_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "20 min",
        },
        "Total_CurrentDirection/Peak_deg_Mean": {
            AxisLabel: "Direction To",
            PlotLine: false,
            Units: "°T TO",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
        },
        "Total_CurrentSpeed/Bottom_kts_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Bottom_mps_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Middle_kts_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Middle_mps_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Peak_kts_1hour_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "Total_CurrentSpeed/Peak_kts_20min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Total_CurrentSpeed/Peak_kts_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "Total_CurrentSpeed/Peak_mps_1hour_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "Total_CurrentSpeed/Peak_mps_20min_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
            Suffix: "20 min",
        },
        "Total_CurrentSpeed/Peak_mps_Mean": {
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
            AllowPlot: true,
            Default: true,
        },
        "VerticalVisibility/ft_Inst": {
            AxisLabel: "Cloud Height",
            PlotLine: false,
            Units: "ft",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
        },
        "Visibility/m_1hour_Mean": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "60 min",
        },
        "Visibility/m_1min_Mean": {
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "WaterTemp/degC_1min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "WindChill/degC_1min_Mean": {
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
            AllowPlot: true,
            Default: true,
            Suffix: "1 min",
        },
        "WindDirection/Backed_deg_2min": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "2 min",
        },
        "WindDirection/Veered_deg_2min": {
            AxisLabel: "Direction From",
            PlotLine: false,
            Units: "°T FROM",
            AllowPlot: true,
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            Suffix: "2 min",
        },
        "WindSpeed/kts_10m_10min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "10 min",
        },
        "WindSpeed/kts_10m_2min_Mean": {
            AxisLabel: "Speed",
            PlotLine: true,
            Units: "kts",
            AllowPlot: true,
            AxisMin: 0,
            Default: true,
            Suffix: "2 min",
        },

        // added by Nicolas after setting up data copy from MET-REACH to MNG (not grouped by type):

        "AirTempDryBulb/degC_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Temperature",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "°C",
        },
        "BarometricPressure/QFE_mbar_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "hPa",
        },
        "BarometricPressure/mbar_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "hPa",
        },
        "BarometricPressure_Cell1/QNH_mbar_4min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "4 min",
            Units: "hPa",
        },
        "BarometricPressure_Cell1/mbar": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Units: "hPa",
        },
        "BarometricPressure_Cell2/QNH_mbar_4min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "4 min",
            Units: "hPa",
        },
        "BarometricPressure_Cell2/mbar": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Units: "hPa",
        },
        "BarometricPressure_Cell3/QNH_mbar_4min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "4 min",
            Units: "hPa",
        },
        "BarometricPressure_Cell3/mbar": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Units: "hPa",
        },
        "BarometricPressure_QNH/mbar_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Pressure",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "hPa",
        },
        "Buoy_BatteryLife/%": {
            AllowPlot: true,
            AxisLabel: "Battery %",
            Default: true,
            PlotLine: true,
            Units: "%",
        },
        "CurrentProfile": {
            AllowPlot: false,
            Default: true,
        },
        "CurrentProfileRaw": {
            AllowPlot: false,
            Default: true,
        },
        "DayNightIndicator": {
            AllowPlot: false,
            Default: true,
        },
        "Dewpoint/degC_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Temperature",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "°C",
        },
        "Heave/Period_s_20min_Max": {
            AllowPlot: true,
            AxisLabel: "Period",
            Default: true,
            PlotLine: true,
            Suffix: "20 min",
            Units: "s",
        },
        "Heave/Period_s_20min_Min": {
            AllowPlot: true,
            AxisLabel: "Period",
            Default: true,
            PlotLine: true,
            Suffix: "20 min",
            Units: "s",
        },
        "Heave/Rate_mps_20min_Mean": {
            AllowPlot: true,
            AxisLabel: "Speed",
            Default: true,
            PlotLine: true,
            Suffix: "20 min",
            Units: "mps",
        },
        "Heave/m_20min_Mean": {
            AllowPlot: true,
            AxisLabel: "Height",
            Default: true,
            PlotLine: true,
            Suffix: "20 min",
            Units: "m",
        },
        "HmaxT/m_30min_CrestToTrough": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
            Units: "m",
        },
        "HmaxT/m_30min_TroughToCrest": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
            Units: "m",
        },
        "HmaxT/m_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
            Units: "m",
        },
        "Hmax_m": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Units: "m",
        },
        "Hs/m_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
            Units: "m",
        },
        "Hs_Swell2/m": {
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Units: "m",
        },
        "InvalidAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M-1/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M-1/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M-2/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M-2/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M0/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M0/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M1/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M1/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M2/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M2/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M3/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M3/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "M4/30min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "M4/45min": {
            AllowPlot: true,
            AxisLabel: "Spectral Moments",
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
        },
        "MeanSpreading/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°",
        },
        "MeanSpreading_Swell1/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°",
        },
        "MeanSpreading_Swell2/deg_30min": {
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            Default: true,
            PlotLine: false,
            Suffix: "30 min",
            Units: "°",
        },
        "MeanSpreading_WindSea/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°",
        },
        "MeanWaveDirection/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "MeanWaveDirection_Swell1/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "MeanWaveDirection_Swell2/deg_30min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "30 min",
            Units: "°T FROM",
        },
        "MeanWaveDirection_WindSea/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "NormalRangeFailAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "PeakWaveDirection/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "PeakWaveDirection_Swell1/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "PeakWaveDirection_WindSea/deg_45min": {
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°T FROM",
        },
        "RainfallIntensity_mmphour": {
            AllowPlot: true,
            AxisLabel: "Rainfall",
            Default: true,
            PlotLine: true,
            Units: "mm / hour",
        },
        "RangeFailAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "RateFailAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: false,
            Suffix: "30 min",
        },
        "RawString": {
            AllowPlot: false,
            Default: true,
        },
        "RelativeHumidity/pc_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Humidity",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "%",
        },
        "SHR/mps_10min_Mean": {
            AllowPlot: true,
            AxisLabel: "Heave Rate",
            Default: true,
            PlotLine: true,
            Suffix: "10 min",
            Units: "mps",
        },
        "SHR/mps_20min_Mean": {
            AllowPlot: true,
            AxisLabel: "Heave Rate",
            Default: true,
            PlotLine: true,
            Suffix: "20 min",
            Units: "mps",
        },
        "SHR/mps_2min_Min": {
            AllowPlot: true,
            AxisLabel: "Heave Rate",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "mps",
        },
        "SHR/mps_Inst": {
            AllowPlot: true,
            AxisLabel: "Heave Rate",
            Default: true,
            PlotLine: true,
            Suffix: "Inst",
            Units: "mps",
        },
        "SensorRange/ft": {
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            Default: true,
            PlotLine: true,
            Units: "ft",
        },
        "SensorStatus": {
            AllowPlot: false,
            Default: true,
        },
        "Skewness/30min": {
            AllowPlot: true,
            AxisLabel: "Skewness",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "SpectrumHighPortion/30min": {
            AllowPlot: true,
            AxisLabel: "Spectrum Energy",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "SpectrumLowPortion/30min": {
            AllowPlot: true,
            AxisLabel: "Spectrum Energy",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "SpikeFilterFailCount/1min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "1 min",
        },
        "SpikeFilterFailCountA/1min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "1 min",
        },
        "SpikeFilterFailCountB/1min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "1 min",
        },
        "SpikeFilterFailCountC/1min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "1 min",
        },
        "StationarityFailAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "T2/s_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
            Units: "s",
        },
        "T2_Swell2/s_30min": {
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
            Units: "s",
        },
        "TEMPSC_Status": {
            AllowPlot: false,
            Default: true,
        },
        "Total_CurrentDirection/Surface_deg_90min_Mean": {
            AllowPlot: true,
            AxisLabel: "Direction To",
            AxisMin: 0,
            AxisMax: 360,
            Default: true,
            PlotLine: false,
            Suffix: "90 min",
            Units: "°T TO",
        },
        "Total_CurrentSpeed/Surface_kts_90min_Mean": {
            AllowPlot: true,
            AxisLabel: "Current Speed",
            Default: true,
            PlotLine: true,
            Suffix: "90 min",
            Units: "kts",
        },
        "Total_SeaElevationAtCmax/m_30min": {
            AllowPlot: true,
            AxisLabel: "Sea Surface",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
            Units: "m",
        },
        "Tp/s_45min": {
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            Default: true,
            PlotLine: true,
            Suffix: "45 min",
            Units: "s",
        },
        "ValidAirGapCount/30min": {
            AllowPlot: true,
            AxisLabel: "Air Gap",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
            Units: "m",
        },
        "ValidValueCount/30min": {
            AllowPlot: true,
            AxisLabel: "Count",
            Default: true,
            PlotLine: true,
            Suffix: "30 min",
        },
        "WaveFiltersStatus": {
            AllowPlot: false,
            Default: true,
        },
        "WaveSpectrum": {
            AllowPlot: false,
            Default: true,
        },
        "WindChill/degC_2min_Mean": {
            AllowPlot: true,
            AxisLabel: "Temperature",
            Default: true,
            PlotLine: true,
            Suffix: "2 min",
            Units: "°C",
        },

        // added by Nicolas - missing from dbo.ParameterListEntries :

        "AirTemperature_degC": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
        },
        "Cass_m": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            PlotLine: true,
            Units: "m",
        },
        "Cmax_m": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            PlotLine: true,
            Units: "m",
        },
        "DewPoint_degC": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
        },
        "First_CloudBaseHeight_ft": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Units: "ft",
        },
        "First_CloudBaseHeight_ft_Inst": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Suffix: "Inst",
            Units: "ft",
        },
        "First_CloudCover": {
            Default: true,
            AllowPlot: false,
        },
        "GustSpeed_kts": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Speed",
            AxisMin: 0,
            PlotLine: true,
            Units: "kts",
        },
        "Heave/m_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Height",
            PlotLine: true,
            Units: "m",
        },
        "Hs_m": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Height",
            AxisMin: 0,
            PlotLine: true,
            Units: "m",
        },
        "MeanSpreading_PrimaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            AxisMin: 0,
            PlotLine: false,
            Units: "°",
        },
        "MeanSpreading_PrimaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            AxisMin: 0,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°",
        },
        "MeanSpreading_SecondaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            AxisMin: 0,
            PlotLine: false,
            Units: "°",
        },
        "MeanSpreading_SecondaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Spreading",
            AxisMin: 0,
            PlotLine: false,
            Suffix: "45 min",
            Units: "°",
        },
        "MeanWaveDirection_PrimaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "MeanWaveDirection_PrimaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "45 min",
        },
        "MeanWaveDirection_SecondaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "MeanWaveDirection_SecondaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "45 min",
        },
        "MeanWaveDirection_Swell1/deg_30min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "30 min",
        },
        "MeanWaveDirection_WindSea/deg_30min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "30 min",
        },
        "MotionAccelerationX/mps2_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Acceleration",
            PlotLine: true,
            Units: "m/s^2",
        },
        "MotionAccelerationY/mps2_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Acceleration",
            PlotLine: true,
            Units: "m/s^2",
        },
        "MotionAccelerationZ/mps2_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Acceleration",
            PlotLine: true,
            Units: "m/s^2",
        },
        "PeakWaveDirection_PrimaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "PeakWaveDirection_PrimaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "45 min",
        },
        "PeakWaveDirection_SecondaryWaveComponent/deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "PeakWaveDirection_SecondaryWaveComponent/deg_45min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
            Suffix: "45 min",
        },
        "Pitch/deg_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
        },
        "QNH_mbar": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Pressure",
            PlotLine: true,
            Units: "hPa",
        },
        "RelativeHumidity_pc": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Humidity",
            PlotLine: true,
            Units: "%",
        },
        "Roll/deg_Raw": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Angle",
            PlotLine: true,
            Units: "°",
        },
        "Second_CloudBaseHeight_ft": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Units: "ft",
        },
        "Second_CloudBaseHeight_ft_Inst": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Units: "ft",
            Suffix: "Inst",
        },
        "Second_CloudCover": {
            Default: true,
            AllowPlot: false,
        },
        "T2_s": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            PlotLine: true,
            Units: "s",
        },
        "T2_Swell1/s_30min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            PlotLine: true,
            Units: "s",
            Suffix: "30 min",
        },
        "T2_WindSea/s_30min": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            PlotLine: true,
            Units: "s",
            Suffix: "30 min",
        },
        "Third_CloudBaseHeight_ft": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Units: "ft",
        },
        "Third_CloudBaseHeight_ft_Inst": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Cloud Height",
            AxisMin: 0,
            PlotLine: false,
            Units: "ft",
            Suffix: "Inst",
        },
        "Third_CloudCover": {
            Default: true,
            AllowPlot: false,
        },
        "Total_CurrentDirection/Surface_deg_Mean_BCM": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: true,
            Units: "° TO",
        },
        "Total_CurrentSpeed/Surface_mps_Mean_BCM": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Current Speed",
            PlotLine: true,
            Units: "m/s",
        },
        "Tp_s": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            PlotLine: true,
            Units: "s",
        },
        "Tz_s": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Wave Period",
            AxisMin: 0,
            PlotLine: true,
            Units: "s",
        },
        "Visibility_m": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Visibility",
            PlotLine: true,
            Units: "m",
        },
        "WindChill_degC": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Temperature",
            PlotLine: true,
            Units: "°C",
        },
        "WindDirection_Backed_deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "WindDirection_deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "WindDirection_Veered_deg": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Direction From",
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false,
            Units: "°T FROM",
        },
        "WindSpeed_kts": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Speed",
            AxisMin: 0,
            PlotLine: true,
            Units: "kts",
        },
        "WindSpeed/mps_10min_Mean": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Speed",
            AxisMin: 0,
            PlotLine: true,
            Units: "m/s",
            Suffix: "10 min",
        },
        "WindSpeed/mps_2min_Mean": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Speed",
            AxisMin: 0,
            PlotLine: true,
            Units: "m/s",
            Suffix: "2 min",
        },
        "WindSpeed/mps_3sec_Mean": {
            Default: true,
            AllowPlot: true,
            AxisLabel: "Speed",
            AxisMin: 0,
            PlotLine: true,
            Units: "m/s",
            Suffix: "3 sec",
        },
    };
}
